import React from 'react';
import { TFunction } from "react-i18next";
import styles from './MainInfoCard.module.scss';
import { CompanyPage } from '../../../../../../hooks/slices/companySlice'; // Adjusted import path
import { CompanyUtil } from '../../../../../../utils/company'; // Adjusted import path
import { Language } from "../../../../../../consts/languages"; // Adjusted import path

interface MainInfoCardProps {
    companyPage: CompanyPage;
    t: TFunction;
    language: Language;
}

export const MainInfoCard: React.FC<MainInfoCardProps> = (props) => {
    const headerText: string = props.t("companyPage.company_info_details_title");
    const companyName: string = CompanyUtil.getCompanyName(props.companyPage, props.language);
    const address: string | undefined = CompanyUtil.getCompanyAddress(props.companyPage);
    const startDateText: string = props.t("companyPage.company_info_start_date_title");
    const startDate: string | undefined = props.companyPage.startDate;

    return (<div className={styles["info-card"]}>
        <h1>{headerText}</h1>
        <p>{companyName}</p>
        <p>{address}</p>
        {startDate && <p>{startDateText + ": " + startDate}</p>}
    </div>)
} 